function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, InputNumber, Upload, message, Drawer } from "antd";
import ImgCrop from 'antd-img-crop';
import { Container, Row, Col } from 'react-bootstrap';
import { Cash, PlusCircleFill, Plus, ShieldFillExclamation, BoxFill } from "react-bootstrap-icons";
import Common from "../includes/Common";
import AddItemCategory from "./AddItemCategory";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EditSellable = function EditSellable(_ref) {
  var handler = _ref.handler,
    item = _ref.item;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showAddCategory = _useState8[0],
    setShowAddCategory = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    deptOptions = _useState0[0],
    setDeptOptions = _useState0[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState1 = useState(""),
    _useState10 = _slicedToArray(_useState1, 2),
    loadError = _useState10[0],
    setLoadError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataChanged = _useState12[0],
    setIsDataChanged = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    providers = _useState14[0],
    setProviders = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    photo = _useState16[0],
    setPhoto = _useState16[1];
  var props = {
    listType: "picture-card",
    onPreview: function onPreview(file) {
      return false;
    },
    onRemove: function onRemove(file) {
      setPhoto(null);
    },
    beforeUpload: function beforeUpload(file) {
      setPhoto(file);
      return false;
    },
    accept: "image/*",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append("id", item.id);
    formData.append('label', values.label);
    formData.append('item_category_id', values.item_category_id);
    formData.append('provider_id', values.provider_id);
    formData.append('recharge_price', values.recharge_price);
    formData.append('consignation_price', values.consignation_price);
    formData.append('purchase_price', values.purchase_price);
    formData.append("photo", photo);
    formData.append('price', values.price);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'editsellable', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    setIsDataChanged(false);
    form.setFieldsValue({
      label: item.label,
      provider_id: item.provider_id,
      recharge_price: item.recharge_price,
      consignation_price: item.consignation_price,
      price: item.price,
      purchase_price: item.purchase_price,
      item_category_id: item.sellable_category_id
    });
    axios.all([axios.get(Common.baseApiUrl + 'getsellablecategories/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getproviders/' + Common.currentUser.id.toString())]).then(function (response) {
      if (response[0].data.status == 200) {
        setDeptOptions([]);
        response[0].data.categories.forEach(function (s) {
          setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: s.id,
              label: s.label
            }]);
          });
        });
      } else {
        setLoadError(response[0].data.message);
      }
      if (response[1].data.status == 200) {
        setProviders([]);
        response[1].data.providers.forEach(function (p) {
          setProviders(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: p.label
            }]);
          });
        });
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      setLoadError('Une erreur est survenue');
    })["finally"](function () {});
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), loadError.length > 0 && /*#__PURE__*/_jsx("div", {
      style: {
        padding: "10px 0px 10px 0px"
      },
      children: /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: loadError,
        showIcon: true
      })
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "large",
      form: form,
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "item_category_id",
            label: "Cat\xE9gorie",
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir une cat\xE9gorie",
              options: deptOptions,
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "provider_id",
            label: "Fournisseur",
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir le fournisseur",
              options: providers,
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }]
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "D\xE9nomination",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "recharge_price",
            label: "Prix recharge",
            children: /*#__PURE__*/_jsx(InputNumber, {
              size: "medium",
              prefix: /*#__PURE__*/_jsx(Cash, {}),
              formatter: function formatter(value) {
                return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
              },
              style: {
                minWidth: "160px"
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "consignation_price",
            label: "Prix consignation",
            children: /*#__PURE__*/_jsx(InputNumber, {
              size: "medium",
              prefix: /*#__PURE__*/_jsx(Cash, {}),
              formatter: function formatter(value) {
                return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
              },
              style: {
                minWidth: "160px"
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "price",
            label: "Prix par d\xE9faut",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              prefix: /*#__PURE__*/_jsx(Cash, {}),
              formatter: function formatter(value) {
                return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
              },
              style: {
                minWidth: "160px"
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "purchase_price",
            label: "Prix \xE0 l'achat",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              prefix: /*#__PURE__*/_jsx(Cash, {}),
              formatter: function formatter(value) {
                return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
              },
              style: {
                minWidth: "160px"
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Photo",
        children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
          children: /*#__PURE__*/_jsx("div", {
            style: {
              padding: "40px 120px"
            },
            children: /*#__PURE__*/_jsx(PlusCircleFill, {
              size: 18
            })
          })
        }))
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(Plus, {}),
          htmlType: "submit",
          disabled: deptOptions.length == 0,
          loading: isFormLoading,
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "Ajouter"
          })
        })
      })]
    })]
  });
};
export default EditSellable;